import { EventEmitter, Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

import {
	SystemNotificationsActions,
	SystemNotificationsData,
	SystemNotificationsResponse
} from '@models/system-notifications.model';

@Injectable()
export class SystemNotificationsServiceDataProvider {
	public systemNotificationChanged: EventEmitter<
		SystemNotificationsData
	> = new EventEmitter<SystemNotificationsData>();
	constructor(private http: HttpClient) {}

	getSystemNotification(): Observable<Object> {
		const url = '/api/user/v1/system notifications/active';
		return this.http.get(url);
	}

	fetchSystemNotificationsData(): Observable<SystemNotificationsData> {
		return this.getSystemNotification().pipe(
			map((data: SystemNotificationsResponse): SystemNotificationsData => {
				this.systemNotificationChanged.emit(data.data);
				return data.data;
			})
		);
	}

	createActionList(actions: SystemNotificationsActions): Array<string> {
		return Object.keys(actions);
	}

	sendSystemNotificationsId(id: string) {
		const url = `/api/user/v1/system notifications/${id}}/mark-as-viewed`;
		return this.http.get(url);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./shared/services/system-notifications/system-notifications.service.ts